module.exports = __webpack_public_path__ + "static/img/bg-01-m_2025.d1724cd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg-01-m_2025.jpg
// module id = Hkxg
// module chunks = 99